<template>
    <div class="content">
        <div class="warp">
            <div class="title">您是否要退出登录？</div>
            <div class="btn">
                <div class="no" @click="no">否</div>
                <div class="yes" @click="yes">是</div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        no() {
            this.$parent.showModal = false
        },
        yes() {
            this.$parent.showModal = false
            this.$cookie.delete('token')
            location.href = `${location.origin}${location.pathname}#/ticket/login?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`


        }
    },
}
</script>
<style scoped lang="scss">
.content{
    position: fixed;
    z-index: 991;
    width: 100%;
    height: 100% !important;
    background-color: rgba($color: #000000, $alpha: 0.6);
}
.warp {
    position: fixed;
    width: 500px;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 16px;
    top: calc(50% - 150px);
    left: calc(50% - 250px);
    z-index: 992;
    color: #000;

    .title {
        font-size: 24px;
        width: 80%;
        margin-bottom: 50px;
    }

    .btn {
        display: flex;
        justify-content: space-between;
        width: 80%;
        margin-top: 50px;

        .no {
            font-size: 22px;
            width: 150px;
            border-radius: 16px;
            border: 1px solid var(--themeColor);
            color: var(--themeColor);
        }

        .yes {
            font-size: 22px;
            font-size: 22px;
            width: 150px;
            border-radius: 16px;
            color: #fff;
            background: var(--themeColor);
        }

    }
}
</style>